import { render, staticRenderFns } from "./94.vue?vue&type=template&id=270abe42&scoped=true&"
import script from "./94.vue?vue&type=script&lang=js&"
export * from "./94.vue?vue&type=script&lang=js&"
import style0 from "./94.vue?vue&type=style&index=0&id=270abe42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270abe42",
  null
  
)

export default component.exports